module.exports = __webpack_public_path__ + "static/media/course.fda0b3e6.svg";